import { navLinks } from "@/mocks/gua";

const footerCols = [
  {
    title: "瓜田导航",
    links: [
      { label: "辐射玩法", href: "#mechanics" },
      { label: "瓜田地图", href: "#map" },
      { label: "热门瓜榜", href: "#hot" },
      { label: "追瓜手记", href: "#feed" },
    ],
  },
  {
    title: "帮助与关于",
    links: [
      { label: "用户口碑", href: "#praise" },
      { label: "常见问题", href: "#faq" },
      { label: "关于我们", href: "#about" },
      { label: "订阅晚报", href: "#subscribe" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-[1200px] px-4 pb-8 pt-14 md:px-6 md:pt-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                吃瓜<span className="text-primary-500">中心</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              以热门事件为圆心，辐射全网热点周边。提供完整的瓜田地图与扩散路径追踪，
              帮你把每一只瓜都看得更完整、更透彻。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-whatsapp-line", "ri-twitter-x-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base font-bold text-foreground-950">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜中心 · 内容仅供参考，请以多方核实信息为准</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-water-flash-line text-primary-500"></i>
            理性吃瓜，健康围观
          </p>
        </div>
      </div>
    </footer>
  );
}